<template>
    <div>
        <b-modal id="upload-payroll" title="Bordro Yükle" scrollable no-close-on-esc no-close-on-backdrop>
            <g-calculate-salary-process-upload-payroll v-model="uploadData"></g-calculate-salary-process-upload-payroll> 
            <template #modal-footer><v-executer :loading="uploading" :action="upload">Yükle</v-executer></template>
        </b-modal>

        <b-card no-body class="mb-1">
            <b-overlay :show="getting" opacity="0.2">
                <div class="p-1">
                    <div class="row align-items-center">
                            <div class="col-md-3 mb-1 mb-md-0">             
                                <b-input-group class="input-group-merge">
                                    <template #prepend>
                                        <b-input-group-text >
                                            <feather-icon icon="SearchIcon"></feather-icon>
                                        </b-input-group-text>
                                    </template>
                                    <b-form-input placeholder="Ara..." v-on:keyup.enter="getData" v-model="searchValue"></b-form-input>
                                </b-input-group>
                            </div>
                            <div class="col-auto">
                                <button class="btn btn-success" v-on:click="getData">Sorgula</button>
                            </div>
                            <!-- <div class="col-auto">
                                <button class="btn btn-info" v-on:click="kasa">Kasa</button>
                            </div> -->
                            <div class="col-md-auto ml-auto">
                                <b-dropdown  :disabled="acting" right variant="primary" >
                                    <template #button-content>
                                        <b-spinner v-if="acting" small/>
                                        <template v-else>İşlemler</template>
                                    </template>
                                </b-dropdown>
                            </div>
                        </div>
                </div>
                <div class="table-responsive">
                    <table class="table table-sm bordered-header">
                        <thead>
                            <tr>
                                <th class="text-center">
                                    <feather-icon icon="MoreHorizontalIcon"/>
                                </th>
                                <th class="w-50">Personel</th>
                                <th class="w-50 text-right">Banka 2</th>
                                <th>Bordro</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(d,i) in (datas || [])" :class="{'bg-light-danger':d.Amount < 0}" :key="i">
                                <td>
                                    <button v-on:click="showUpload(d)" v-b-tooltip.noninteractive.bottom.hover="'Yükle'" class="btn btn-flat-secondary btn-icon btn-xs">
                                        <feather-icon icon="UploadIcon"/>
                                    </button> 
                                </td>
                                <td>{{ $safe(d,'EmployeeFullName') }}</td>
                                <td class="text-right">{{ $safe(d,'AmountStr') }}</td>
                                <td>
                                    <b-badge v-if="d.FilePath == null" variant="secondary">Yüklenmemiş</b-badge>
                                    <button v-else v-on:click="downloadFile(d)" class="btn btn-xs w-100 btn-primary">İndir</button>
                                </td>
                            </tr>
                            <tr v-if="(datas || []).length == 0">
                                <td colspan="100" class="text-center">Henüz bir veri bulunmamaktadır.</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="mx-75 mb-1" v-if="count > 0">
                    <div class="row justify-content-md-between justify-content-center">
                        <div class="col-auto mb-1 mb-md-0">
                            <div class="d-flex align-items-center text-nowrap">
                                Toplam {{(count || 0)}} kayıt arasından
                                <select class="form-control form-control-sm mx-50 per-page-select" v-model="perPage">
                                    <option v-for="pp in perPages" :key="pp" :value="pp">{{pp}}</option>
                                </select>
                                gösteriliyor.   
                            </div>
                        </div>
                        <div class="col-auto mb-1 mb-md-0">
                            <b-pagination class="mb-0" v-model="page" :total-rows="((count || 0))" :per-page="perPage"></b-pagination>
                        </div>
                    </div>
                </div>
            </b-overlay>
        </b-card>
        <b-card no-body class="p-50">
            <div class="row justify-content-end">
                <div class="col-auto">
                    <button class="btn btn-sm btn-outline-secondary" v-on:click="$emit('back')">Geri</button>
                </div>
            </div>
        </b-card>
    </div>
</template>

<script>
import { BCard, BInputGroup, BInputGroupText, BFormInput, BOverlay, BBadge, BDropdown, BPagination, VBTooltip } from 'bootstrap-vue'
import EmployeeOperationsApi from '@/api/employee-operations'
import GCalculateSalaryProcessUploadPayroll from './GCalculateSalaryProcessUploadPayroll.vue';
import Additional from '@/utilities/additional';

export default {
    components:{
        BCard,
        BInputGroup,
        BInputGroupText,
        BFormInput,
        BOverlay,
        BBadge,
        BDropdown,
        BPagination,
        GCalculateSalaryProcessUploadPayroll
    },
    directives:{
        'b-tooltip':VBTooltip
    },
    props:{
        donem:{
            type:Object,
            default:()=>({
                year:null,
                month:null
            })
        },
        filter:{
            type:Object,
            default:() => ({})
        },
    },
    watch:{
        "page"(oldV,newV){
            if(oldV && newV && oldV != newV){
                this.getData()
            }
        },
        "perPage"(oldV,newV){
            if(oldV && newV && oldV != newV){
                this.getData()
            }
        }
    },
    data(){
        return {
            acting:false,
            getting:false,
            tableResult:null,
            datas:[],
            count:0,
            searchValue:'',
            page:1,
            perPage:10,
            perPages:[10,20,30,40,50,100],
            uploading:false,
            uploadData:{
                GSalaryPaymentId:null,
                File:null
            }
        }
    },
    methods:{
        showUpload(item){
            this.uploadData.GSalaryPaymentId = null
            this.uploadData.File = null
            this.uploadData.GSalaryPaymentId = item.Id
            this.$showModal('upload-payroll')
        },
        getData(){
            this.getting = true
            EmployeeOperationsApi.GSalary.PayrollUploadTable({
                ...this.filter,
                PaginateRequest:{
                    IsAscending:true,
                    OrderColumnName:'FullName',
                    QueryParam:this.searchValue,
                    Skip:this.page,
                    Take:this.perPage
                }
            }).then(res => {
                if(res.data.Success){
                    this.tableResult = null
                    this.datas = res.data.Data.Data.Data || []
                    this.count = res.data.Data.Data.TotalCount || 0
                }
                this.getting =false
            }).catch(err =>{
                this.$result(null,err)
                this.getting = false
            })
        },
        
        downloadFile(item){
            if(item.FilePath){
                Additional.DownloadTab(item.FilePath)
            }
        },
        async upload(){
            this.uploading = true
            let formData = await Additional.ToFormData(this.uploadData,['File'])
            EmployeeOperationsApi.GSalary.UploadPayroll(formData).then(res => {
                if(res.data.Success){
                    this.getData()
                    this.$hideModal('upload-payroll')
                }
                this.$result(res)
                this.uploading = false
            }).catch(err => {
                this.uploading = false
                this.$result(null,err)
            })
        }
    }
}
</script>